import React, { HTMLAttributes } from 'react';
import classNames from 'classnames';

import styles from './typography.module.css';

export interface Props extends Omit<HTMLAttributes<HTMLElement>, 'color'> {
	children: React.ReactNode;
	className?: string;
	as?: string;
	fontWeight?: 'bold' | 'regular';
	fontSize?: 'large' | 'big' | 'medium' | 'small' | 'tiny';
	color?: ColorType;
	transform?: 'none' | 'uppercase' | 'capitalize';
	htmlFor?: string;
	value?: string | number;
}

/**
 * Typography Component
 */
export const Typography: React.FC<Props> = (props) => {
	const {
		children,
		className = '',
		as = 'div',
		fontSize = 'medium',
		color = '',
		transform = 'none',
		fontWeight = 'regular',
		...restProps
	} = props;

	const finalClassName = classNames(
		className,
		styles.container,
		color,
		`transform-${transform}`,
		styles[fontSize],
		styles[fontWeight]
	);

	return React.createElement(
		as,
		{
			...restProps,
			style: {
				...props.style,
			},
			className: finalClassName,
		},
		children
	);
};
